import { Retailer } from './enums';
export const getNonQBRetailerCanonical = article => {
  const {
    retailer_links,
    retailer
  } = article;
  const retailerId = retailer && retailer.id ? retailer.id : undefined;
  if (retailerId && retailer_links && retailer_links[retailerId] && retailerId !== Retailer.supermarkt && retailerId !== Retailer.leshop && retailerId !== Retailer.migros_online) {
    const isQB = Object.keys(retailer_links).filter(retailer => {
      if (retailer === Retailer.supermarkt || retailer === Retailer.leshop || retailer === Retailer.migros_online) {
        return true;
      }
      return false;
    }).length > 0;
    if (isQB) {
      return undefined;
    }
    return retailer_links[retailerId].canonical ? retailer_links[retailerId].canonical : undefined;
  }
  return undefined;
};